import { firebaseApp } from "@/config/firebase";
import firebase from "firebase/app";
const db = firebase.firestore(firebaseApp);

function gameProvider() {}

async function getEvents() {
  let events = [];
  const eventsRef = db.collection("events");
  const data = await eventsRef.get();
  if (data.empty) {
    console.log("No matching documents.");
    return;
  }
  data.forEach((doc) => {
    let event = doc.data();
    event.id = doc.id;
    events.push(event);
  });
  return events;
}
gameProvider.getEvents = getEvents;

async function getEvent(id) {
  const eventsRef = db.collection("events");
  const data = await eventsRef.doc(id).get();
  if (data.empty) {
    console.log("No matching documents.");
    return;
  }
  let event = data.data();
  event.id = data.id;
  return event;
}
gameProvider.getEvent = getEvent;

async function getExperiencePages(id) {

  let posts = []
  return getEvent(id).then(function (event) {
    posts = event.experiencePages;
    posts = posts.sort((a, b) => a.order - b.order);

    return posts;
  });
}
gameProvider.getExperiencePages = getExperiencePages;


async function deleteSingleGame(gameId) {
  await db.collection("events").doc(gameId).delete();
  return getEvents().then(function (events) {
    return events;
  });
}
gameProvider.deleteSingleGame = deleteSingleGame;

async function addSingleGame(game) {
  await db.collection("events").add(game);
  return getEvents().then(function (events) {
    return events;
  });
}
gameProvider.addSingleGame = addSingleGame;

async function editSingleGame(gameId, game) {
  await db
    .collection("events")
    .doc(gameId)
    .set(game)
    .then(function () {
      return getEvent(gameId).then(function (event) {
        return event;
      });
    });
}
gameProvider.editSingleGame = editSingleGame;

export default gameProvider;
